import { convert } from 'html-to-text'
import { FROALA_TAGS } from '../constants/froala.constants'

export const checkIsHtml = (text = '') =>
  FROALA_TAGS.some((tag) => {
    const regexp = new RegExp(`<${tag}`, 'i')
    return regexp.test(text)
  })

export const parseTextFromHtml = (text = '') => {
  const htmlCommentsRegexp = new RegExp(/<!--(.*?)-->/gm, 'g')
  let textCopy = text.replace(htmlCommentsRegexp, '')

  FROALA_TAGS.forEach((tag) => {
    const openTagRegexp = new RegExp(`<${tag}>`, 'g')
    const openTagWithAttributesRegexp = new RegExp(`<${tag}[^>]+>`, 'g')
    const closeTagRegexp = new RegExp(`</${tag}>`, 'g')

    textCopy = textCopy.replace(openTagRegexp, '').replace(openTagWithAttributesRegexp, '').replace(closeTagRegexp, '')
  })

  return textCopy
}

export const appendAsteriskToTheEnd = (text: string, withAsterisk: boolean) => {
  if (!withAsterisk || !text) {
    return {
      htmlMessage: text,
      fallbackRequired: true,
    }
  }

  const options = {
    wordwrap: null,
  }

  const parsedText = convert(text, options)
  const parts = parsedText.split(/\s+/)
  const lastWord = parts[parts.length - 1]
  const lastIndex = text.lastIndexOf(lastWord)

  if (!lastWord || lastIndex === -1) {
    return {
      htmlMessage: text,
      fallbackRequired: true,
    }
  }

  const before = text.slice(0, lastIndex + lastWord.length)
  const after = text.slice(lastIndex + lastWord.length)

  return {
    htmlMessage: `${before}<span class='asterisk'>*</span>${after}`,
    fallbackRequired: false,
  }
}
